var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "importModal",
    attrs: {
      id: "import-clients-modal",
      "modal-dialog-scrollable": false,
      "footer-close-button-text": _vm.$t("global.words.close"),
      "modal-footer": !_vm.loading,
      "modal-dialog-size": "lg",
    },
    on: { show: _vm.handleShow, hidden: _vm.handleHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$t("application.messages.importClients.title")) +
                "\n    "
            ),
            _c(
              "span",
              { attrs: { id: "import-applications" } },
              [
                _c("icon", {
                  staticClass: "tooltip-info",
                  attrs: { name: "question-circle" },
                }),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _vm.loading
              ? _c("loader")
              : _c(_vm.currentComponent, {
                  tag: "component",
                  attrs: {
                    "filogix-details": _vm.filogixDetailsLocal,
                    code: _vm.verificationCode,
                    "expert-deal-id": _vm.expertDealId,
                    "selected-import-type": _vm.selectedImportType,
                    "start-date": _vm.startDate,
                    "end-date": _vm.endDate,
                    "filter-by-status": _vm.filterByStatus,
                    "status-list": _vm.statusList,
                  },
                  on: {
                    "update:filogixDetails": function ($event) {
                      _vm.filogixDetailsLocal = $event
                    },
                    "update:filogix-details": function ($event) {
                      _vm.filogixDetailsLocal = $event
                    },
                    "update:code": function ($event) {
                      _vm.verificationCode = $event
                    },
                    "update:expertDealId": function ($event) {
                      _vm.expertDealId = $event
                    },
                    "update:expert-deal-id": function ($event) {
                      _vm.expertDealId = $event
                    },
                    "update:selectedImportType": function ($event) {
                      _vm.selectedImportType = $event
                    },
                    "update:selected-import-type": function ($event) {
                      _vm.selectedImportType = $event
                    },
                    "update:startDate": function ($event) {
                      _vm.startDate = $event
                    },
                    "update:start-date": function ($event) {
                      _vm.startDate = $event
                    },
                    "update:endDate": function ($event) {
                      _vm.endDate = $event
                    },
                    "update:end-date": function ($event) {
                      _vm.endDate = $event
                    },
                    "update:filterByStatus": function ($event) {
                      _vm.filterByStatus = $event
                    },
                    "update:filter-by-status": function ($event) {
                      _vm.filterByStatus = $event
                    },
                    "update:statusList": function ($event) {
                      _vm.statusList = $event
                    },
                    "update:status-list": function ($event) {
                      _vm.statusList = $event
                    },
                  },
                }),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  id: "import-clients-button",
                  "class-name": "btn-sm",
                  disabled: _vm.$v.$invalid,
                  loading: _vm.submit.loading,
                  "loading-succeeded": _vm.submit.loadingSucceeded,
                },
                on: { finish: _vm.goToNextStep, click: _vm.handleImportSubmit },
              },
              [_vm._v("\n      " + _vm._s(_vm.actionButtonText) + "\n    ")]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }